import api from './api';

// getUser, getUserReviews, getUserLists, getUserComments, getUserBookmarks는
// 현재는 userApi와 동일한 응답을 받지만, 이후 권한이 분리될 수 있어 별도로 유지합니다.
export const adminApi = {
  getFeedPosts: async (query = '') => {
    const params = query.trim() ? `?q=${encodeURIComponent(query.trim())}` : '';
    const response = await api.getAuth(`/admin/app/feeds${params}`);
    return response.data;
  },

  createFeedPost: async (data) => {
    const response = await api.postAuth('/admin/app/feeds', data);
    return response.data;
  },

  updateFeedPost: async (id, data) => {
    const response = await api.putAuth(`/admin/app/feeds/${id}`, data);
    return response.data;
  },

  deleteFeedPost: async (id) => {
    const response = await api.deleteAuth(`/admin/app/feeds/${id}`);
    return response.data;
  },

  getSafetyReports: async (status) => {
    const params = status ? `?status=${encodeURIComponent(status)}` : '';
    const response = await api.getAuth(`/admin/safety/reports${params}`);
    return response.data;
  },

  updateSafetyReport: async (reportId, data) => {
    const response = await api.putAuth(`/admin/safety/reports/${reportId}`, data);
    return response.data;
  },

  getDirectCatalogGenres: async () => {
    const response = await api.getAuth('/admin/direct-catalog/genres');
    return response.data;
  },

  getDirectCatalogMetadata: async (data) => {
    const response = await api.postAuth('/admin/direct-catalog/metadata', data);
    return response.data;
  },

  importDirectCatalogSourceCover: async (data) => {
    const response = await api.postAuth('/admin/direct-catalog/source-cover', data);
    return response.data;
  },

  preflightDirectCatalogAlbum: async (data) => {
    const response = await api.postAuth('/admin/direct-catalog/preflight', data);
    return response.data;
  },

  createDirectCatalogAlbum: async (data) => {
    const response = await api.postAuth('/admin/direct-catalog/albums', data);
    return response.data;
  },

  getCounts: async () => {
    const response = await api.getAuth('/admin/counts');
    return response.data;
  },
  getUsers: async (page, size, q, isActive, isWithdrawn, sortBy, sortOrder) => {
    const response = await api.getAuth(
      `/admin/users?page=${page}&size=${size}&q=${encodeURIComponent(q || '')}&isActive=${isActive}&isWithdrawn=${isWithdrawn}&sortBy=${sortBy}&sortOrder=${sortOrder}`,
    );
    return response.data;
  },

  getUser: async (userId) => {
    const response = await api.getAuth(`/admin/users/${userId}`);
    return response.data;
  },

  getUserReviews: async (userId) => {
    const response = await api.getAuth(`/admin/users/${userId}/reviews`);
    return response.data;
  },

  getUserLists: async (userId) => {
    const response = await api.getAuth(`/admin/users/${userId}/lists`);
    return response.data;
  },

  getUserComments: async (userId) => {
    const response = await api.getAuth(`/admin/users/${userId}/comments`);
    return response.data;
  },

  getUserBookmarks: async (userId) => {
    const response = await api.getAuth(`/admin/users/${userId}/saved`);
    return response.data;
  },

  updateUserProfile: async (userId, data) => {
    const response = await api.putAuth(`/admin/users/${userId}`, data);
    return response.data;
  },

  updateUsersStatus: async (data) => {
    const response = await api.putAuth(`/admin/users/status`, {
      userIds: data.userIds,
      isActive: data.isActive,
      reason: data.reason,
    });
    return response.data;
  },

  // 회원 강제 탈퇴
  withdrawUsers: async (userIds, reason) => {
    const response = await api.putAuth(`/admin/users/withdraw`, {
      userIds,
      reason,
    });
    return response.data;
  },

  // 회원 등급 변경
  updateUsersGrade: async (userIds, grade) => {
    const response = await api.putAuth(`/admin/users/grade`, {
      userIds,
      grade,
    });
    return response.data;
  },

  // 회원 재가입 가능 여부 변경
  updateUsersRejoinable: async (userIds, isRejoinable) => {
    const response = await api.putAuth(`/admin/users/rejoinable`, {
      userIds,
      isRejoinable,
    });
    return response.data;
  },

  // 배너 목록 조회 (PC, MOBILE 그룹화)
  getBanners: async () => {
    const response = await api.getAuth('/admin/banners');
    return response.data;
  },

  // 배너 생성
  createBanner: async (data) => {
    const response = await api.postAuth('/admin/banners', data);
    return response.data;
  },

  // 배너 삭제 (다중)
  deleteBanners: async (bannerIds) => {
    const response = await api.delete('/admin/banners', {
      data: { bannerIds },
      requireAuth: true,
    });
    return response.data;
  },

  // 배너 순서 변경
  updateBannerOrder: async (bannerIds) => {
    const response = await api.putAuth('/admin/banners/order', { bannerIds });
    return response.data;
  },

  // 배너 단건 조회
  getBanner: async (bannerId) => {
    const response = await api.getAuth(`/admin/banners/${bannerId}`);
    return response.data;
  },

  // 배너 수정
  updateBanner: async (bannerId, data) => {
    const response = await api.putAuth(`/admin/banners/${bannerId}`, data);
    return response.data;
  },

  // 홈 앨범 관리 - 전체 조회
  getHomeAlbums: async () => {
    const response = await api.getAuth('/admin/home-albums');
    return response.data;
  },

  // 홈 앨범 관리 - 순서 변경
  updateHomeAlbumOrder: async (section, albumIds) => {
    const response = await api.putAuth(`/admin/home-albums/${section}/order`, { albumIds });
    return response.data;
  },

  // 포스트팝 추천 앨범 목록 - 최신순 순서 변경
  updateRecommendedAlbumOrder: async (albumIds) => {
    const response = await api.putAuth('/admin/recommended-albums/order', { albumIds });
    return response.data;
  },

  // 홈 앨범 관리 - 광고 마크 설정/해제
  updateHomeAlbumAdMark: async (section, albumIds, visibleAlbumIds, isAdMarked) => {
    const response = await api.putAuth(`/admin/home-albums/${section}/ad-mark`, {
      albumIds,
      visibleAlbumIds,
      isAdMarked,
    });
    return response.data;
  },

  // 홈 앨범 관리 - 포스트팝 추천 코멘트 수정
  updateRecommendedAlbumComment: async (
    albumId,
    recommendationComment,
    recommendationCommentEn,
  ) => {
    const response = await api.putAuth(`/admin/home-albums/recommended/${albumId}/comment`, {
      recommendationComment,
      recommendationCommentEn,
    });
    return response.data;
  },

  updateRecommendedAlbumCommentBySource: async (
    sourceId,
    albumSource,
    recommendationComment,
    recommendationCommentEn,
  ) => {
    const response = await api.putAuth('/admin/home-albums/recommended/comment', {
      sourceId,
      albumSource,
      recommendationComment,
      recommendationCommentEn,
    });
    return response.data;
  },

  // 숨긴 앨범 관리 - 목록 조회
  getHiddenAlbums: async (page, size, q, sortBy, sortOrder) => {
    const params = new URLSearchParams({
      page: page.toString(),
      size: size.toString(),
    });
    if (q) params.append('q', q);
    if (sortBy) params.append('sortBy', sortBy);
    if (sortOrder) params.append('sortOrder', sortOrder);
    const response = await api.getAuth(`/admin/hidden-albums?${params.toString()}`);
    return response.data;
  },

  // 숨긴 앨범 관리 - 숨김 해제
  unhideAlbums: async (albumIds) => {
    const response = await api.putAuth('/admin/hidden-albums/unhide', { albumIds });
    return response.data;
  },

  // 홈 리뷰 관리 - 전체 조회 (legacy)
  getHomeReviews: async () => {
    const response = await api.getAuth('/designated-reviews');
    return response.data;
  },

  // 홈 리뷰 관리 - 등록 해제 (다중)
  deleteDesignatedReviews: async (type, reviewIds) => {
    const response = await api.delete(`/designated-reviews/${type}`, {
      data: { reviewIds },
      requireAuth: true,
    });
    return response.data;
  },

  // 홈 리뷰 관리 - 순서 변경
  updateDesignatedReviewOrder: async (type, reviewIds) => {
    const response = await api.putAuth(`/designated-reviews/${type}/order`, { reviewIds });
    return response.data;
  },

  // 홈 리뷰 관리 - 광고 마크 설정/해제
  updateAdMark: async (type, reviewIds, isAdMarked) => {
    const response = await api.putAuth(`/designated-reviews/${type}/ad-mark`, {
      reviewIds,
      isAdMarked,
    });
    return response.data;
  },

  // P 마크 앨범 목록 조회
  getStarredAlbums: async (page, size, q, sortBy, sortOrder) => {
    const params = new URLSearchParams({
      page: page.toString(),
      size: size.toString(),
    });
    if (q) params.append('q', q);
    if (sortBy) params.append('sortBy', sortBy);
    if (sortOrder) params.append('sortOrder', sortOrder);
    const response = await api.getAuth(`/admin/starred-albums?${params.toString()}`);
    return response.data;
  },

  // P 마크 해제
  unstarAlbums: async (albumIds) => {
    const response = await api.delete('/admin/starred-albums', {
      data: { albumIds },
      requireAuth: true,
    });
    return response.data;
  },

  // 활성 앨범 목록 조회 (리뷰 또는 북마크가 있는 앨범)
  getActiveAlbums: async (page, size, q, sortBy, sortOrder) => {
    const params = new URLSearchParams({
      page: page.toString(),
      size: size.toString(),
    });
    if (q) params.append('q', q);
    if (sortBy) params.append('sortBy', sortBy);
    if (sortOrder) params.append('sortOrder', sortOrder);
    const response = await api.getAuth(`/admin/active-albums?${params.toString()}`);
    return response.data;
  },

  // P 마크 추가
  starAlbums: async (albumIds) => {
    const response = await api.postAuth('/admin/active-albums/star', { albumIds });
    return response.data;
  },

  getSponsoredCampaigns: async () => {
    const response = await api.getAuth('/admin/ads');
    return response.data;
  },

  searchSponsoredAlbums: async (query) => {
    const response = await api.getAuth(`/admin/ads/catalog/albums?q=${encodeURIComponent(query)}`);
    return response.data;
  },

  resolveSponsoredAlbum: async (album) => {
    const response = await api.postAuth('/admin/ads/catalog/albums/resolve', {
      sourceId: album.sourceId,
      albumSource: album.albumSource,
    });
    return response.data;
  },

  searchSponsoredArtists: async (query) => {
    const response = await api.getAuth(`/admin/ads/catalog/artists?q=${encodeURIComponent(query)}`);
    return response.data;
  },

  resolveSponsoredArtist: async (artist) => {
    const response = await api.postAuth('/admin/ads/catalog/artists/resolve', {
      sourceId: artist.id,
      artistSource: artist.artistSource,
    });
    return response.data;
  },

  createSponsoredCampaign: async (data) => {
    const response = await api.postAuth('/admin/ads', data);
    return response.data;
  },

  updateSponsoredCampaign: async (campaignId, data) => {
    const response = await api.putAuth(`/admin/ads/${campaignId}`, data);
    return response.data;
  },

  setSponsoredCampaignActive: async (campaignId, isActive, expectedIsActive) => {
    const response = await api.putAuth(`/admin/ads/${campaignId}/active`, {
      isActive,
      expectedIsActive,
    });
    return response.data;
  },

  deleteSponsoredCampaign: async (campaignId) => {
    const response = await api.delete(`/admin/ads/${campaignId}`, { requireAuth: true });
    return response.data;
  },
};
